<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <form novalidate [formGroup]="pinCodeForm" (ngSubmit)="onSubmit()" class="loginForm">
        <p class="text">Please enter your six digit Memorable Number</p>
        <div *ngIf="showError">
          <div class="error-message text-center">Wrong Memorable Number</div>
        </div>
        <div class="pin-wrapper">
          <np-ptt-pin showCursor="false" showPinCode="false" showCaret="false" class="pin" type="number" length="6" formControlName="pin">
          </np-ptt-pin>
        </div>
        <div class="forget-pin">
          <a routerLink="/auth/login/reset-memorable-number" class="link"> Forgotten your Memorable Number? </a>
        </div>
        <p class="notify">
          This is the 6 digit Memorable Number that you have chosen for your account
        </p>
        <div class="mb-3 px-3">
          <button type="submit" class="btn btn-block" [ngClass]="{
            'btn-greengo': pinCodeForm.valid,
            'btn-inactive': !pinCodeForm.valid
          }" npFocusOutClicked>Continue</button>
        </div>
        <p class="footer px-3 px-md-0">
          By logging in you agree to {{brandName}} Limited's
          <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy" class="link">Privacy Policy</a>
          and
          <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/terms-of-use-website/" class="link">Terms of Use</a>
        </p>
      </form>
    </div>
  </div>
</div>